import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  backgroundImage: {
    md?: string;
    _?: string;
  };
  header: {
    title: string;
    description: string;
  };
  interests: {
    left: { value: string; }[];
    right: { value: string; }[];
    other: {
      visible: boolean;
      maxLength: string;
    };
  };
  footer: {
    buttonText: string;
    disclaimerText: string;
  };
  successModal: {
    header: string;
    body: string;
  };
  api: {
    path: string;
  },
}

const propsSchema: PropsSchemaList = [
  {
    key: 'backgroundImage',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: '_',
        label: 'Mobile (or Base)',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'md',
        label: 'Desktop',
        type: types.S3_ASSET_URL,
      },
    ],
  },
  {
    key: 'header',
    label: 'Header',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'interests',
    label: 'Interests',
    type: types.OBJECT,
    children: [
      {
        key: 'left',
        label: 'Left Checkboxes',
        type: types.ARRAY,
        children: [
          {
            key: 'value',
            label: 'Value',
            type: types.TEXT,
          },
        ]
      },
      {
        key: 'right',
        label: 'Right Checkboxes',
        type: types.ARRAY,
        children: [
          {
            key: 'value',
            label: 'Value',
            type: types.TEXT,
          },
        ]
      },
      {
        key: 'other',
        label: 'Other Checkbox',
        type: types.OBJECT,
        children: [
          {
            key: 'visible',
            label: 'Visible',
            type: types.BOOLEAN,
          },
          {
            key: 'maxLength',
            label: 'Max Length',
            type: types.TEXT,
          },
        ]
      },
    ],
  },
  {
    key: 'footer',
    label: 'Footer',
    type: types.OBJECT,
    children: [
      {
        key: 'buttonText',
        label: 'Submit Button Text',
        type: types.TEXT,
      },
      {
        key: 'disclaimerText',
        label: 'Disclaimer Text',
        type: types.TINYMCE,
      },
    ],
  },
  {
    key: 'successModal',
    label: 'Success Modal',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TEXT,
      },
      {
        key: 'body',
        label: 'Body',
        tooltip: `{{email}} in the body will be replaced by the user's email address`,
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'api',
    label: 'API',
    type: types.OBJECT,
    children: [
      {
        key: 'path',
        label: 'API Path',
        type: types.TEXT,
      },
    ],
  },
];

const defaultProps: Props = {
  backgroundImage: {
    md: 'https://genesis-cdn.ff.com/assets/pages/subscribe_landing/subscribe_desktop.png',
    _: 'https://genesis-cdn.ff.com/assets/pages/subscribe_landing/subscribe_mobile.png',
  },
  header: {
    title: 'Get Updates',
    description: 'Subscribe to our newsletter and stay on top of our latest announcements.',
  },
  interests: {
    left: [
      { value: "FF 91 2.0 Futurist Alliance" },
      { value: "FF 91 2.0 Futurist" },
      { value: "FF 91 2.0" },
      { value: "Scheduling a Demo Drive" },
    ],
    right: [
      { value: "Charging and Servicing" },
      { value: "FF aiHypercar+" },
      { value: "Futurist Product Office (FPO) Program" },
      { value: "FF Referral Program" },
    ],
    other: {
      visible: true,
      maxLength: '50',
    }
  },
  footer: {
    buttonText: 'Subscribe',
    disclaimerText: `By clicking "Subscribe" you agree to our Terms of Use and Privacy Policy, including providing your consent to receive email marketing communications from Faraday Future such as updates on relevant FF news, products and services.  You may unsubscribe from the email marketing communications at any time.`
  },
  successModal: {
    header: 'SUCCESS',
    body: `We have subscribed you to the newsletter with the following address: {{email}}`
  },
  api: {
    path: '/api/subscribe'
  }
};

export default {
  title: 'Subscribe Interests',
  id: 'SubscribeInterests',
  propsSchema,
  defaultProps,
}
